import { standardNoteNames } from '@tunasong/schemas'
import { getAllNoteNames } from '../note/index.js'
import { ChordBuilder } from './chord-builder.js'
import type { ChordVariant } from './chord-types.js'
import { ALL_CHORD_ELEMENT_TYPES, ALL_CHORD_TRIAD_TYPES, ALL_CHORD_TYPES } from './chord-types.js'
import { getName } from './get-name.js'

/** Generate a map from note names to Chords */
export const notesToChords: { [notesKey: string]: ChordVariant[] } = {}
export const ALL_CHORDS: { [name: string]: { chord: ChordVariant; builder: ChordBuilder; isAlias: boolean } } = {}

for (const note of getAllNoteNames()) {
  for (const triad of ALL_CHORD_TRIAD_TYPES) {
    const c = ChordBuilder.create(note).add(triad)
    notesToChords[c.getNoteSignature()] = notesToChords[c.getNoteSignature()] || []
    notesToChords[c.getNoteSignature()].push(c.getChord())

    const chord = { chord: c.getChord(), builder: c, isAlias: false }
    const chordName = getName(c.getChord())
    ALL_CHORDS[chordName] = chord
    // Aliases
    const aliases = c.getAliasNames()
    for (const alias of aliases) {
      ALL_CHORDS[alias] = { ...chord, isAlias: true }
    }

    //  Generate the elements only for triads and suspended
    if (triad !== '' && triad !== 'm' && triad !== 'sus' && triad !== 'sus2' && triad !== 'sus4') {
      continue
    }
    for (const element of ALL_CHORD_ELEMENT_TYPES) {
      /** Suspended chords come last - e.g., C7sus2 */
      const isSuspended = triad.match(/sus/)
      const e1 = isSuspended ? element : triad
      const e2 = isSuspended ? triad : element
      const c2 = ChordBuilder.create(note).add(e1).add(e2)
      notesToChords[c2.getNoteSignature()] = notesToChords[c2.getNoteSignature()] || []
      notesToChords[c2.getNoteSignature()].push(c2.getChord())

      const chord = { chord: c2.getChord(), builder: c2, isAlias: false }
      const chordName = getName(c2.getChord())
      ALL_CHORDS[chordName] = chord

      const aliases = c2.getAliasNames()
      for (const alias of aliases) {
        ALL_CHORDS[alias] = { ...chord, isAlias: true }
      }
    }
  }
}

/** A chord built only from types the pickers offer (see `offered` on the chord spec) */
const isOffered = (builder: ChordBuilder) =>
  builder.elementNames.every(element => ALL_CHORD_TYPES[element]?.offered !== false)

/** The chords the pickers and suggestions offer. Every library chord still parses and voices when typed. */
export const getAllChords = () =>
  Object.values(ALL_CHORDS)
    .filter(c => !c.isAlias && (standardNoteNames as readonly string[]).includes(c.chord.root) && isOffered(c.builder))
    .map(c => c.chord)
